import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ILayoutStore } from '../../store/LayoutStore'
import { IUserStore } from '../../store/UserStore'
import { IWeekConsumptionStore } from '../../store/WeekConsumptionStore'
import { WeekDays } from '../../constants/weekDays'
import CardButton from '../CardButton/CardButton'
import Drawer from '../Drawer/Drawer'
import EditResponse from '../EditResponse/EditResponse'
import ValidateButton from '../ValidateButton/ValidateButton'
// import { saveData } from '../../services/resultHelper'
import { IStepState } from '../Step/Step'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { tag } from '../../services/ATInternetService'
import IddleMessage from '../IddleMessage/IddleMessage'

export interface IStepWeekConsumptionState {
  selectedDays: number[]
  noneChecked: boolean
}

interface IStepWeekConsumptionProps extends RouteComponentProps<any> {
  LayoutStore?: ILayoutStore
  UserStore?: IUserStore
  WeekConsumptionStore?: IWeekConsumptionStore
  stepState: IStepState
  onChange: (change: object) => void
  onResetAnswer: () => void
}

@inject('UserStore', 'LayoutStore', 'WeekConsumptionStore')
@observer
class StepWeekConsumption extends React.Component<
  IStepWeekConsumptionProps,
  IStepWeekConsumptionState
> {
  public constructor(props: IStepWeekConsumptionProps) {
    super(props)
    this.state = {
      noneChecked: false,
      selectedDays: this.props.UserStore!.consumptionDays,
    }
  }

  public render() {
    const daysOfWeek = [...WeekDays]

    let list

    if (this.state.noneChecked) {
      list = (
        <li key={`weekeconsumption-li-none}`}>
          <CardButton variant="response" label="aucun" />
        </li>
      )
    } else {
      list = this.state.selectedDays.sort().map((selectedDay) => (
        <li key={`weekeconsumption-li-${WeekDays[selectedDay - 1].value}`}>
          <CardButton variant="response" label={WeekDays[selectedDay - 1].label} />
        </li>
      ))
    }

    return (
      <fieldset>
        <legend className="Row Row--mw500">
          <p>Au cours de la semaine dernière :</p>
          <p>Quel(s) jour(s) avez-vous consommé de l'alcool ?</p>
        </legend>
        {this.props.stepState.isAnswered && (
          <div className="Row Row--center">
            <ul className="listInline">{list}</ul>
            <EditResponse functionEdit={this.props.onResetAnswer} />
          </div>
        )}

        {!this.props.stepState.isAnswered && (
          <Drawer>
            <div>
              <ul className="Drawer-days">
                {daysOfWeek.map((day) => {
                  return (
                    <React.Fragment key={`week_${day.value}`}>
                      <li>
                        <CardButton
                          label={day.label}
                          variant="input"
                          idForLabel={`week_${day.value}`}
                        >
                          <input
                            className="visuallyHidden"
                            type="checkbox"
                            id={`week_${day.value}`}
                            name={`week_${day.value}`}
                            onChange={this.pickDay}
                            value={day.value}
                            checked={this.state.selectedDays.indexOf(day.value) !== -1}
                          />
                        </CardButton>
                      </li>
                    </React.Fragment>
                  )
                })}
                <React.Fragment key={`week_0`}>
                  <li>
                    <CardButton variant="input" label="Aucun" idForLabel="week_0">
                      <input
                        className="visuallyHidden"
                        type="checkbox"
                        id="week_0"
                        name="week_0"
                        onChange={this.pickDay}
                        value="0"
                        checked={this.state.noneChecked}
                      />
                    </CardButton>
                  </li>
                </React.Fragment>
              </ul>
            </div>
          </Drawer>
        )}

        {!this.props.stepState.isAnswered && this.props.stepState.needValidation && (
          <div className="control-color-wrapper">
            <ValidateButton onClick={this.validateDays} />
          </div>
        )}

        {!this.props.stepState.isAnswered && !this.props.stepState.needValidation && (
          <div className="control-color-wrapper">
            <IddleMessage iddleMessageLabel="Sélectionnez les jours où vous avez bu de l'alcool" />
          </div>
        )}
      </fieldset>
    )
  }

  private validateDays = () => {
    tag.sendPage({ elem: this, name: 'jours_ok', chapter1: 'Questionnaire' })
    this.props.UserStore!.setConsumptionDays(this.state.selectedDays.sort())
    this.props.WeekConsumptionStore!.cleanWeekConsumption(this.state.selectedDays)
    this.props.onChange({ isAnswered: true })
  }

  private pickDay = (day: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDay = parseInt(day.target.value, 10)
    if (selectedDay === 0) {
      if (day.target.checked) {
        this.setState({
          selectedDays: [],
          noneChecked: true,
        })

        this.props.onChange({ needValidation: true })
      } else {
        this.setState({ selectedDays: [], noneChecked: false })
        this.props.onChange({ needValidation: false })
      }
    } else {
      let currentDaysChecked = this.state.selectedDays

      // a normal day of the week
      if (day.target.checked) {
        // Add day to array
        if (!currentDaysChecked.some((currentDay) => selectedDay === currentDay)) {
          currentDaysChecked.push(selectedDay)
        }
      } else {
        currentDaysChecked = currentDaysChecked.filter((currentDay) => currentDay !== selectedDay)
      }

      this.setState({
        selectedDays: currentDaysChecked,
        noneChecked: false,
      })
      this.props.onChange({
        needValidation: currentDaysChecked.length !== 0,
      })
    }
  }
}

export default withRouter(StepWeekConsumption)



// WEBPACK FOOTER //
// ./src/components/StepWeekConsumption/StepWeekConsumption.tsx